import React from 'react';
import { Link } from 'react-router-dom';
import ProductShelfSection from '../ProductShelfSection';
import { HOME_COPY_DEFAULTS } from '../../content/pageCopyDefaults';

/** Editorial blog teaser row on the home page. */
export default function HomeBlogSection({ blogContent, homeCopy = {} }) {
  const posts = Array.isArray(blogContent?.posts) ? blogContent.posts : [];
  if (!posts.length) return null;

  const actionLabel = homeCopy.blog_view_all_label || HOME_COPY_DEFAULTS.blog_view_all_label;

  return (
    <ProductShelfSection
      eyebrow={homeCopy.blog_eyebrow || HOME_COPY_DEFAULTS.blog_eyebrow}
      title={blogContent.section_title}
      actionHref="/blog"
      actionLabel={actionLabel}
      layout="grid"
      className="home-blog-shelf"
      ariaLabel="Styling stories"
    >
      {posts.slice(0, 3).map((post) => (
        <article className="home-blog-card product-shelf__cell" key={post.slug}>
          <Link to={`/blog/${post.slug}`} className="home-blog-card__link">
            <p className="home-blog-card__eyebrow">Story</p>
            <h3 className="home-blog-card__title">{post.title}</h3>
            <span className="home-blog-card__read">
              Read article
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </span>
          </Link>
        </article>
      ))}
    </ProductShelfSection>
  );
}
